export const initial = {
  keyword: '',
  working: false,
  result: [],
  selected: {}
};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'SEARCH_USER_WORKING':
      return { ...state, working: action.payload };
    case 'SEARCH_USER_KEYWORD':
      return { ...state, keyword: action.payload };
    case 'SEARCH_USER_SET_RESULT':
      return { ...state, result: action.payload };
    case 'SEARCH_USER_SELECT':
      return { ...state, selected: action.payload };
    case 'SEARCH_USER_CLEAR':
      return initial;
    default:
      return state;
  }
};
